import type MultiSelectedDashOuterManager from '@src/slide/application/service/multi-selected-dash-outer/core';
import { IMultiSelectedDashOuterManager } from '@src/slide/application/service/multi-selected-dash-outer/core/multi-selected-dash-outer-manager.interface';
import { IDynamicServiceConfig } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';

// eslint-disable-next-line max-len
export const getMultiSelectedDashOuterManagerDynamicConfig = (...args: ConstructorParameters<typeof MultiSelectedDashOuterManager>) => {
    const multiSelectedDashOuterManagerDynamicConfig: IDynamicServiceConfig<IMultiSelectedDashOuterManager> = {
        name: 'multi-selected-dash-outer-manager',
        loadType: 'on-demand',
        async module() {
            const Ctor = (await import('@src/slide/application/service/multi-selected-dash-outer/core')).default;
            return new Ctor(...args);
        },
    };
    return multiSelectedDashOuterManagerDynamicConfig;
};
